<script lang="ts">
  import { onMount } from "svelte";

  import { AUTH_EVENT, completeLogin } from "../../lib/auth";
  import { resolveAppConfig } from "../../lib/config";
  import { router } from "../../lib/router.svelte";

  let error = $state("");

  onMount(async () => {
    const code = router.search.get("code");
    const state = router.search.get("state");
    if (!code || !state) {
      error = "Missing code/state in callback URL.";
      return;
    }
    try {
      const cfg = await resolveAppConfig();
      const { returnTo } = await completeLogin(cfg.oidc, { code, state });
      window.dispatchEvent(new Event(AUTH_EVENT));
      router.navigate(returnTo || "/account");
    } catch (e) {
      error = e instanceof Error ? e.message : "Sign-in failed";
    }
  });
</script>

<section class="max-w-md mx-auto px-6 py-24 text-center">
  {#if error}
    <p class="text-red-400">{error}</p>
  {:else}
    <p class="text-slate-400">Completing sign-in…</p>
  {/if}
</section>
